import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import * as _ from 'lodash';

interface Props
{
}


import './Clouds.scss';

export default class Clouds extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    render()
    {
        return <div styleName={'clouds'}/>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/map/Clouds.tsx